import { render, staticRenderFns } from "./TosList.vue?vue&type=template&id=7d62ad3f"
import script from "./TosList.vue?vue&type=script&lang=js"
export * from "./TosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports